import React from "react";
import { Button, InputJson } from "../../../nq-component";
import {
  getObjectUseCase,
  updateObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import ForgotFormPagePresenter from "./ForgotPassFormPagePresenter";
import { Link } from "react-router-dom";
import InputFactory from "../../../components/InputFactory";
import FormFactory from "../../../components/FormFactory";
import resetPassSchema from "./resetPassSchema.json";

class ForgotPassFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new ForgotFormPagePresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      updateObjectUseCase(),
      getCurrentUserUseCase(),
    );
  }

  getCollectionName() {
    return "users";
  }

  getSessionId() {
    return this.getParams().sessionId;
  }

  async showSuccess(message, title) {
    const options = {
      title: title || "Success",
      message: message,
      icon: "bi bi-check-circle",
      type: "success",
      positiveButton: "OK",
      negativeButton: false,
    };

    try {
      await this.showDialog(options);

      this.navigateTo("/signin");
    } catch (error) {}
  }

  render() {
    const { progress } = this.state;
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="bg-white rounded p-4">
            <div className="text-center mb-4">
              <img
                className="img-fluid login-img"
                alt="company logo"
                src="/lgs.jpeg"
                style={{ maxWidth: "150px", height: "auto" }}
              />
            </div>

            <div className="p-2 p-lg-4">
              <h2
                className="fw-bold text-center mb-2"
                style={{ color: "#d18237" }}
              >
                Set New Password
              </h2>
              <p className="text-black-50 text-center mb-4">
                Create a strong password to secure your account
              </p>

              <form
                onSubmit={this.onSubmitForm.bind(this)}
                className="d-flex flex-column align-items-center"
              >
                <FormFactory
                  schema={resetPassSchema}
                  onChange={this.onChange.bind(this)}
                  object={{}}
                />

                <div className="col-12 col-lg-6 mt-3">
                  <Button
                    style={{ backgroundColor: "#d18237" }}
                    type="submit"
                    className="btn text-white w-100 fw-bold py-2 fs-6"
                    disabled={progress}
                  >
                    {progress ? "Please wait..." : "Confirm Password"}
                  </Button>
                </div>

                <div className="col-12 text-center">
                  <Link
                    to={`/signin`}
                    className="text-decoration-none fw-medium"
                    style={{ color: "#d18237" }}
                  >
                    <i className="bi bi-arrow-left me-1"></i>Back to Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ForgotPassFormPage);
